<template>
	<v-app-bar
		app
		color="primary"
		dark
		height="50"
		elevation="1"
	>
        <v-app-bar-nav-icon @click="$emit('drawer')" class="me-2"></v-app-bar-nav-icon>
        <h1 class="text-uppercase text-body-1">{{$T(`routes.${$route.meta.i18nTranslateKey}`)}}</h1>
		<v-spacer/>

		<v-btn
			small
			text
			@click="changeI18nLang($i18n.locale !== 'ar' ? 'ar' : 'en')"
		>
			{{$i18n.locale !== 'ar' ? 'العربية' : 'English'}}
			<v-icon size="18" class="ms-2">mdi-earth</v-icon>
		</v-btn>
		
		<!-- loading line -->
		<v-progress-linear
			indeterminate
			absolute
			bottom
			:active="loading"
			height="4"
			background-color="primary"
			color="secondary lighten-1"
		></v-progress-linear>
    </v-app-bar>
</template>

<script>
import { changeI18nLang } from '@/i18n/i18n'
export default {
	props: [
		'loading'
	],

	methods: {
		changeI18nLang
	}
}
</script>

<style>

</style>